import en from './en'
import cn from './cn'
import id from './id'
import kh from './kh'
import my from './my'
import th from './th'
import vi from './vi'
export default {
  en,
  'zh-cn': cn,
  id,
  kh,
  my,
  th,
  vi
}
